/* eslint-disable */
import React, { PropTypes } from 'react';
import './css/RatingStar.css'
import $ from 'jquery';
import ConfigD from './util/ConfigD';

class RatingCkb extends React.Component {

  constructor(props, context) {
    super(props, context);
    
    this.mouseOverImg = this.mouseOverImg.bind(this);
    this.mouseOutImg = this.mouseOutImg.bind(this);
    this.clickImg = this.clickImg.bind(this);
    this.selecionarRange = this.selecionarRange.bind(this);
  }

  selecionarRange(){

  }
  mouseOverImg(e){
      this.props.mouseOverImg(e);
  }

  mouseOutImg(){
    this.props.mouseOutImg();
  }

  clickImg(e){
    $('input:checkbox').prop('checked',false);
    for (var i = 0; i < $('input:checkbox').length; ++i) {
      var ckb = $('input:checkbox')[i];
      //console.log('ckb.value', ckb.value)
      //console.log('valor ', e)
      if(ckb.value<e){
        $(ckb).prop('checked',true);
      }
      else{
        break
      }
    }
    this.props.clickImg(e, this.props.pergunta);


  }

  componentWillReceiveProps(nextProps) {
    //console.log('reiniciar pagina', nextProps.reiniciarPagina)
    if (nextProps.reiniciarPagina) {
        $('input:checkbox').prop('checked',false);
    }
  }

  render() {
    
    return (
      
        <div className="star-selector centerRow">
          <input id={'star_1'+this.props.pergunta.mIdCampanhaPergunta} type="checkbox" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="1"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/star1.png)'}} className="startStar-cc" htmlFor={'star_1'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(1)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(1)}></label>
          <input id={'star_2'+this.props.pergunta.mIdCampanhaPergunta} type="checkbox" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="2"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/star2.png)'}} className="startStar-cc" htmlFor={'star_2'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(2)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(2)}></label>
          <input id={'star_3'+this.props.pergunta.mIdCampanhaPergunta} type="checkbox" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="3"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/star3.png)'}} className="startStar-cc" htmlFor={'star_3'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(3)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(3)}></label>
          <input id={'star_4'+this.props.pergunta.mIdCampanhaPergunta} type="checkbox" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="4"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/star4.png)'}} className="startStar-cc" htmlFor={'star_4'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(4)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(4)}></label>
          <input id={'star_5'+this.props.pergunta.mIdCampanhaPergunta} type="checkbox" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="5"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/star5.png)'}} className="startStar-cc" htmlFor={'star_5'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(5)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(5)}></label>
          <input id={'star_6'+this.props.pergunta.mIdCampanhaPergunta} type="checkbox" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="6"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/star6.png)'}} className="startStar-cc" htmlFor={'star_6'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(6)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(6)}></label>
          <input id={'star_7'+this.props.pergunta.mIdCampanhaPergunta} type="checkbox" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="7"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/star7.png)'}} className="startStar-cc" htmlFor={'star_7'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(7)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(7)}></label>
          <input id={'star_8'+this.props.pergunta.mIdCampanhaPergunta} type="checkbox" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="8"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/star8.png)'}} className="startStar-cc" htmlFor={'star_8'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(8)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(8)}></label>
          <input id={'star_9'+this.props.pergunta.mIdCampanhaPergunta} type="checkbox" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="9"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/star9.png)'}} className="startStar-cc" htmlFor={'star_9'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(9)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(9)}></label>
          <input id={'star_10'+this.props.pergunta.mIdCampanhaPergunta} type="checkbox" name={'perg'+this.props.pergunta.mIdCampanhaPergunta} value="10"/>
          <label style={{backgroundImage:'url('+ConfigD.getServerBase() + '/img/rating/star10.png)'}} className="startStar-cc" htmlFor={'star_10'+this.props.pergunta.mIdCampanhaPergunta}  onMouseOver={()=>this.mouseOverImg(10)} onMouseOut={this.mouseOutImg} onClick={()=>this.clickImg(10)}></label>
        </div>

    );
  }
}
RatingCkb.contextTypes = {
  router: React.PropTypes.object
};



export default RatingCkb;



/** WEBPACK FOOTER **
 ** ./src/components/RatingStar.js
 **/